<template>
  <div class="confirm-user-details" v-bind:class="{ 'confirm-user-details--missing': !profile.email }">
    <div class="confirm-user-details__container">
      <div class="confirm-user-details__header">
        <a @click="cancel()" @keyup.enter="cancel()" class="confirm-user-details__abort" tabindex="0">Avbryt</a>
        <h2 class="text-t2 confirm-user-details__title mb-4" v-if="profile.email">Har vi rätt kontaktuppgifter till dig?</h2>
        <h2 class="text-t2 confirm-user-details__title" v-else>Vi saknar en e-post till dig</h2>


        <p class="confirm-user-details__intro" v-if="(profile.preferredContactMethod == 'letter' || profile.preferredContactMethod == '') && profile.email==''">Vi kommer fortsättningsvis endast skicka information via e-post. Du har ingen e-postadress hos oss idag och måste därför lägga in den nedan.</p>
        <p class="confirm-user-details__intro" v-else-if="(profile.preferredContactMethod == 'letter' || profile.preferredContactMethod == '')">Vi kommer fortsättningsvis endast skicka information via e-post. </p>
        <p class="confirm-user-details__intro" v-else-if="profile.email">Kontrollera gärna att vi har rätt kontaktuppgifter till dig så att vi kan hålla dig uppdaterad om t. ex en intresseanmälan eller en felanmälan.</p>
        <p class="confirm-user-details__intro" v-else>Har du någon e-post? För att enklare kunna hålla dig uppdaterad om t. ex en intresseanmälan eller en felanmälan ber vi dig om din epost. Om du har några frågor kontakta gärna kundservice.</p>
      </div>
      <div class="confirm-user-details__inner">
        <div class="confirm-user-details--email" v-if="!profile.email || profile.preferredContactMethod == 'letter' || profile.preferredContactMethod == ''">
          <form class="emailform" @submit.prevent="submit()">
            <div class="emailform__input-field confirm-user-details--missingmail">
              <label class="emailform__form-label">E-postadress <span class="confirm-user-details--red">*</span></label>
              <p :class="{ 'control': true }">
                <input
                  v-model="editableProfile.email"
                  required="true"
                  placeholder="Ange en epostadress"
                  name="email"
                  type="text"
                  autocomplete="off"/>
  <!--              :class="{ input: true, 'is-danger': errors.email }"-->
  <!--              <span v-show="errors.email" class="emailform__error help is-danger">{{ errors.first('email') }}</span>-->
              </p>
              <div class="contactinfoform__profileform__input-field" v-if="profile.preferredContactMethod == 'letter' || profile.preferredContactMethod == ''">
                <br /><label>Föredraget kontaktsätt</label><br /><input type="checkbox" value="preferredContactMethod" checked disabled> E-post</input>
              </div>
            </div>
          </form>
        </div>

        <div class="confirm-user-details__details">
          <h3 class="confirm-user-details__details__title" v-if="!profile.email">Kontrollera alla kontaktuppgifter</h3>
          <div class="confirm-user-details__details--name" v-if="who"><span>Namn:</span> {{who}}</div>
          <div class="confirm-user-details__icon">
            <IconHouse /> <span>Adress:</span> {{profile.postalAddress}}<br />{{profile.zipCode}} {{profile.city}} <!--<a v-if="!profile.email" @click="editDetails()" tabindex="0" class="confirm-user-details__edit-link">Ändra</a>-->
          </div>
          <div class="confirm-user-details__icon" v-if="profile.phoneMobile">
            <IconPhone2 /> Telefon mobil: {{profile.phoneMobile}} <!--<a v-if="!profile.email" @click="editDetails()" tabindex="0" class="confirm-user-details__edit-link">Ändra</a>-->
          </div>
          <div class="confirm-user-details__icon" v-if="profile.phoneHome">
            <IconPhone2 /> Telefon hem: {{profile.phoneHome}} <!--<a v-if="!profile.email" @click="editDetails()" tabindex="0" class="confirm-user-details__edit-link">Ändra</a>-->
          </div>
          <div class="confirm-user-details__icon" v-if="profile.phoneMobile2">
            <IconPhone2 /> Telefon: {{profile.phoneMobile2}} <!--<a v-if="!profile.email" @click="editDetails()" tabindex="0" class="confirm-user-details__edit-link">Ändra</a>-->
          </div>
          <div class="confirm-user-details__icon" v-if="profile.phoneMobile3">
            <IconPhone2 /> Telefon: {{profile.phoneMobile3}} <!--<a v-if="!profile.email" @click="editDetails()" tabindex="0" class="confirm-user-details__edit-link">Ändra</a>-->
          </div>
          <div class="confirm-user-details__icon " v-if="profile.email">
            <IconEmail2 /> <span>Epost:</span> {{profile.email}}
          </div>

          <button class="confirm-user-details__link" tabindex="0" @click="editDetails()"><span>Ändra uppgifter</span></button>
        </div>

      </div>

      <div class="confirm-user-details__footer confirm-user-details__buttons">
        <div class="flex flex-col md:flex-row gap-2 w-full md:justify-end flex-col-reverse">
          <Button variant="secondary" tabindex="0" @click="editDetails()">Nej, jag vill uppdatera</Button>
          <Button variant="primary" tabindex="0" size="large" v-if="!profile.email || profile.preferredContactMethod == 'letter' || profile.preferredContactMethod == ''" :disabled="!profile.email && !editableProfile.email" id="email" @click="submit()" :loading="loading" loadingText="Sparar">Spara</Button>
          <Button variant="primary" tabindex="0" @click="confirmDetails()" :loading="loading" v-else>Ja, de stämmer</Button>

        </div>
        <p v-if="errormsg">{{errormsg}}</p>
      </div>

    </div>
    <div class="confirm-user-details__background"></div>

  </div>
</template>
<script>
import Button from '@/components/ui/button';
import IconHouse from '@/components/icons/IconHouse';
import IconPhone2 from '@/components/icons/IconPhone2';
import IconEmail2 from '@/components/icons/IconEmail2';
import { mapGetters } from 'vuex';
import VueCookies from 'vue-cookies';
import Loader from '@/components/ui/loader';

export default {
  name: 'ConfirmUserDetails',
  components: { Loader, Button, IconHouse, IconPhone2, IconEmail2 },
  data() {
    return {
      loading: false,
      editableProfile: {},
      errormsg: null,
    };
  },
  watch: {
    profile: {
      deep: true,
      immediate: true,
      handler(profile) {
        this.editableProfile = { ...profile };
      },
    },
  },
  methods: {
    cancel() {
      //if(!this.profile.email) VueCookies.set("credentialsConfirmed", true, 60 * 60); //expires in 1 hour
      VueCookies.set('credentialsConfirmed', true, 60 * 60 * 24 * 2); //expires in 2 days

      this.$emit('done');
    },

    confirmDetails() {
      //expires in 90 days
      //VueCookies.set("credentialsConfirmed", true, 60 * 60 * 24 * 90);
      //this.$emit('done');

      this.loading = true;

      return this.$store
        .dispatch('confirmDetails')
        .then((result) => {
          this.$emit('done');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    editDetails() {
      window.location.href = '#/profil';
    },

    submit() {
      /*return this.$validator.validateAll().then((result) => {
        if (result) {*/
      this.loading = true;
          this.editableProfile.preferredContactMethod = 'email';
          return this.$store
            .dispatch('saveProfile', this.editableProfile)
            .then(() => {
              return this.$store.dispatch('fetchProfile');
            })
            .then((profile) => {
              this.confirmDetails();
              this.$emit('done');
            })
            .finally(() => {
              this.loading = false;
            })
            .catch((err) => {
              this.loading = false;
              const emailError = err.response.data.errors.find((x) => x.field === 'email');
              if (emailError && emailError.code === 'alreadyExists') {
                this.errormsg = 'Det finns redan ett konto där e-posten används, vänligen försök igen.';
                /*this.$validator.errors.add({
                  field: 'email',
                  msg: 'Det finns redan ett konto där e-posten används, vänligen försök igen.',
                });*/
              }
            });
        }
      /*});
    },*/
  },
  computed: {
    ...mapGetters({
      profile: 'profile',
      address: 'address',
    }),

    who() {
      const profile = this.$store.getters.profile;

      if (!profile || !profile.firstName) {
        if (profile && profile.companyName) return profile.companyName;
        else return '';
      }

      return profile.firstName + ' ' + profile.lastName;
    },
  },

  created() {
    return Promise.all([this.$store.cache.dispatch('fetchProfile')]).finally(() => {});
  },
};
</script>
